import type { PropsWithChildren } from 'react';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { Flex, Text } from '@atlaskit/primitives/compiled';

import { ConfluenceEdition } from '../Upgrade/__types__/waitForEditionChangeQuery';
import { SectionMessage } from '../UpsellLooknFeel/SectionMessage';

export const i18n = defineMessages({
	inspectPermissions: {
		id: 'change-edition.share-and-restrict-dialog.inspect-permissions.upsell-title',
		defaultMessage: 'Inspect permissions',
		description: 'Text for title for inspect permissions upsell',
	},
	inspectPermissionsUpsellInfo: {
		id: 'change-edition.share-and-restrict-dialog.inspect-permissions.upsell-info',
		defaultMessage:
			'Upgrade to Premium to troubleshoot how users are being denied access to content.',
		description:
			'Text for the upsell for inspect permissions drop down action when user is on free or standard edition',
	},
	learnMoreLink: {
		id: 'change-edition.share-and-restrict-dialog.inspect-permissions.learn-more-link',
		defaultMessage: 'Learn more',
		description:
			'The text of the hyperlink which takes the user to a page explaining the feature Page Restrictions',
	},
});

type ChangeEditionSectionMessageInspectPermissionsProps = PropsWithChildren<{}>;

const SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION =
	'https://support.atlassian.com/confluence-cloud/docs/manage-permissions-on-the-page-level/';

export const ChangeEditionSectionMessageInspectPermissions = ({
	children,
}: ChangeEditionSectionMessageInspectPermissionsProps) => {
	const { formatMessage } = useIntl();

	return (
		<SectionMessage
			withGradient={false}
			title={formatMessage(i18n.inspectPermissions)}
			body={
				<Flex direction="column" gap="space.050">
					<Text>{formatMessage(i18n.inspectPermissionsUpsellInfo)}</Text>
					{children}
				</Flex>
			}
			learnMoreLink={{
				href: SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION,
				ariaLabel: i18n.learnMoreLink,
			}}
			source="shareAndRestrictDialogUpsell"
			customPadding="0"
			targetEdition={ConfluenceEdition.PREMIUM}
			upgradeEditionActionSubjectId="inspectPermissionsUpsellTryNow"
		/>
	);
};
